<template>
  <div class="container resultView">
    <div>
      <span class="back" @click="back">
        <i class="el-icon-arrow-left"></i> 返回
      </span>
    </div>
    <div class="commonWhiteBg">
      <div class="commonTitle">提交预览</div>
      <div class="MainStepsForm">
        <div class="formWrap">
          <el-form ref="form" :model="form" label-width="140px">
            <el-form-item label="存证文件" prop="evidenceFile">
              <span v-for="(file, index) in form.files" :key="index"
                >{{ file.sourceName }}
              </span>
            </el-form-item>
            <el-form-item label="监测名称" prop="subject">
              {{ form.subject }}
            </el-form-item>
            <el-form-item label="监测关键词" prop="keyWords">
              {{ form.keyWords }}
            </el-form-item>

            <el-form-item label="监测截止时间" prop="time">
              {{ form.timeText }}
            </el-form-item>
            <el-form-item label="监测范围" prop="platform">
              <multiple-select
                v-model="form.platform"
                :isResultView="true"
                :listOpt="constants.platform"
              ></multiple-select>
            </el-form-item>
            <el-form-item
              label="支付方式"
              prop="payStyle"
              class="choosePayStyle"
            >
              <el-radio-group v-model="form.paymode">
                <el-radio label="vip" v-if="form.paymode == 'vip'">
                  <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{vipInfo?vipInfo.detectCount:0}}次）</span
                  >
                </el-radio>
                <el-radio label="alipay" v-if="form.paymode == 'alipay'">
                  <i class="iconfont aliPayColor"> &#xe634; </i>
                  <span>支付宝支付</span></el-radio
                >
                <!-- <el-radio label="wechat" v-if="form.paymode == 'wechat'">
                  <i class="iconfont weChatColor"> &#xe633; </i>
                  <span>微信支付</span></el-radio
                > -->
              </el-radio-group>
            </el-form-item>
            <el-form-item class="submitRow">
              <el-button type="primary" @click="onGoPay">确认并支付</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <pay-dialog ref="payDialog" @close="onSetPayDialogClose"></pay-dialog>
  </div>
</template>

<script>
import multipleSelect from "../../../../../components/form/multipleSelect";
import PayDialog from "@/views/multipleService/components/PayDialog";
import { applyDetectOrder } from "@/api/EvidenceService";
import constants from "@/utils/constants";
import { mapGetters } from "vuex";
export default {
  name: "registerResultView",
  components: { multipleSelect, PayDialog },
  props: {
    form: Object,
  },
  data() {
    return {
      constants,
      isPayDialogVisible: false,
    };
  },
    computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice","vipInfo"]),
  },
  created() {
    this.init();
    this.form.timeText = this.dayjs(this.form.time).format(
      "YYYY-MM-DD HH:mm:ss "
    );
  },
  methods: {
    init() {
      console.log("init result ..");
    },
    back() {
      this.$emit("set-tab-idx", "tab1");
    },
    onGoPay() {
      let that=this;
      if(that.order){
          that.$refs.payDialog.showDialog(this.order);
          that.isPayDialogVisible = true;
          return false;
      }
      let params = {
        detectPlatform: this.form.platform,
        endTime: Math.round(this.form.time / 1000),
        items: this.form.files,
        keyword: this.form.keyWords.split(","),
        paymode: this.form.paymode,
        subject: this.form.subject,
      };

      applyDetectOrder(params).then(({ data }) => {
        that.order = data;
        if(data.paymentStatus=='21'){
          that.bus.$emit('refreshVip');
          that.onSetPayDialogClose(true);
        }else{
          that.$refs.payDialog.showDialog(data);
          that.isPayDialogVisible = true;
        }
      });
    },
    onSetPayDialogClose(result) {
      console.log(result);
      if (result) {
        //跳转至详情页
        this.$router.push({
          path: "/Monitor/Detail",
          query: { orderNo: this.order.orderNo },
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../../../assets/css/inputForm.scss";
</style>
